import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import ActionButtons, { EditButton, DeleteButton } from '../../components/ActionButtons';
import DataTable from '../../components/DataTable';
import ModalShell from '../../components/ModalShell';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

function MisafirTipiForm({ kayit, onKaydet, onGeri, kaydediliyor, hata }) {
  const yeni = !kayit;
  const [ad, setAd] = useState(kayit?.ad ?? '');
  const [fiyat, setFiyat] = useState(kayit?.gecelikFiyat ?? 0);
  const [kisiBazliFiyat, setKisiBazliFiyat] = useState(kayit?.kisiBazliFiyat ?? 0);
  const [hatalar, setHatalar] = useState({});

  const INP = (hata) =>
    `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${hata ? 'border-rose-400 bg-rose-50 focus:border-rose-500 shadow-rose-50 shadow-inner' : 'border-gray-100 focus:border-violet-400 focus:ring-4 focus:ring-violet-50 shadow-sm'
    }`;

  async function handleKaydet() {
    if (!ad.trim()) { setHatalar({ ad: 'Misafir tipi adı zorunludur.' }); return; }
    onKaydet({ ...(kayit ? { misafirTipiId: kayit.misafirTipiId } : {}), ad: ad.trim().toUpperCase(), gecelikFiyat: fiyat, kisiBazliFiyat });
  }

  return (
    <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center p-0 lg:p-4 backdrop-blur-md animate-fade-in shadow-2xl">
      <div className="bg-white w-full max-w-xl rounded-none lg:rounded-[2.5rem] shadow-2xl flex flex-col overflow-hidden border border-white/20 animate-scale-in">
        {/* Modal Header */}
        <div className="relative flex items-center justify-between px-8 py-7 bg-gradient-to-r from-violet-600 to-purple-700 overflow-hidden">
          <div className="absolute top-0 right-0 -mr-12 -mt-12 w-48 h-48 bg-white/10 rounded-full blur-2xl pointer-events-none" style={{ transform: 'translateZ(0)', willChange: 'transform' }}></div>
          <div className="relative flex items-center gap-4">
            <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center text-2xl shadow-inner border border-white/30">
              {yeni ? '➕' : '✏️'}
            </div>
            <div>
              <h2 className="text-white font-black text-lg tracking-tight uppercase leading-none">{yeni ? 'Yeni Misafir Tipi' : `"${kayit.ad}" Düzenle`}</h2>
              <p className="text-white/70 text-[10px] font-bold uppercase tracking-widest mt-1.5 opacity-80 leading-none">Misafir kategorileri ve fiyata özel politikalar</p>
            </div>
          </div>
          <button onClick={onGeri} className="relative z-10 text-white/60 hover:text-white w-10 h-10 flex items-center justify-center rounded-xl hover:bg-white/10 transition-all text-xl">✕</button>
        </div>

        <div className="flex-1 overflow-y-auto px-8 py-8 space-y-6 no-scrollbar">
          {(hata || hatalar.genel) && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hata || hatalar.genel}</div>}

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">MİSAFİR TİP ADI *</label>
            <input value={ad} onChange={e => { setAd(e.target.value.toUpperCase()); setHatalar({}); }}
              className={INP(hatalar.ad)} placeholder="ÖRN: VİP, KAMU, SİVİL" autoFocus onKeyDown={e => e.key === 'Enter' && handleKaydet()} />
            <FormHata mesaj={hatalar.ad} />
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">GECELİK EK / ÖZEL FİYAT (ODA BAŞI)</label>
            <div className="relative">
              <input type="number" value={fiyat} onChange={e => setFiyat(Math.max(0, +e.target.value))}
                className={INP(false) + ' pr-12 text-center h-[54px] shadow-inner font-black text-lg'} min={0} step={0.01} />
              <span className="absolute right-5 top-1/2 -translate-y-1/2 font-black text-gray-300 text-sm">₺</span>
            </div>
            <p className="text-[9px] font-bold text-violet-400 mt-4 uppercase tracking-[0.15em] border-l-4 border-violet-100 pl-4 bg-violet-50/30 py-2 rounded-r-xl leading-relaxed">ODA BAŞI GECELİK ÖZEL FİYAT. 0 İSE ODA FİYATI GEÇERLİDİR.</p>
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">KİŞİ BAZLI GECELİK FİYAT</label>
            <div className="relative">
              <input type="number" value={kisiBazliFiyat} onChange={e => setKisiBazliFiyat(Math.max(0, +e.target.value))}
                className={INP(false) + ' pr-12 text-center h-[54px] shadow-inner font-black text-lg'} min={0} step={0.01} />
              <span className="absolute right-5 top-1/2 -translate-y-1/2 font-black text-gray-300 text-sm">₺</span>
            </div>
            <p className="text-[9px] font-bold text-emerald-400 mt-4 uppercase tracking-[0.15em] border-l-4 border-emerald-100 pl-4 bg-emerald-50/30 py-2 rounded-r-xl leading-relaxed">KİŞİ BAŞI GECELİK ÖZEL FİYAT. 0 İSE KİŞİ BAZLI FİYAT TANIMLI DEĞİL.</p>
          </div>

          {ad.trim() && (
            <div className="bg-violet-50/30 rounded-[2rem] p-6 border-2 border-violet-100 border-dashed animate-fadeIn flex items-center gap-6 leading-none shadow-sm shadow-violet-50">
              <div className="w-16 h-16 bg-gradient-to-br from-violet-500 to-purple-600 rounded-2xl flex items-center justify-center text-3xl shadow-xl shadow-violet-100/50 transform-gpu group-hover:scale-110 transition-transform">
                {ad.trim()[0]}
              </div>
              <div className="text-left flex-1 min-w-0">
                <span className="block font-black text-gray-800 text-lg uppercase tracking-tight mb-2.5 truncate">{ad.trim()}</span>
                <div className="flex flex-wrap gap-2">
                  <span className={`text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg border leading-none inline-block ${fiyat > 0 ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-gray-100 text-gray-400 border-gray-200'}`}>
                    {fiyat > 0 ? `${fiyat.toFixed(2)} ₺ / ODA/GECE` : 'STANDART ODA FİYATI'}
                  </span>
                  {kisiBazliFiyat > 0 && (
                    <span className="text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg border leading-none inline-block bg-blue-50 text-blue-600 border-blue-100">
                      {kisiBazliFiyat.toFixed(2)} ₺ / KİŞİ/GECE
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="px-8 py-6 flex gap-4 justify-end border-t border-gray-50 bg-gray-50/50">
          <button onClick={onGeri} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-violet-600 to-purple-700 hover:from-violet-700 hover:to-purple-800 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-violet-200 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase">
            {kaydediliyor ? '⌛ KAYDEDİLİYOR...' : '💾 KAYDET'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function MisafirTipleri() {
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState(null);
  const [view, setView] = useState('liste');
  const [secili, setSecili] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [arama, setArama] = useState('');
  const [siralama, setSiralama] = useState('ad');
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const veriYukle = useCallback(async () => {
    setYukleniyor(true); setHata(null);
    try { setListe((await apiRequest('misafirtipleri')) || []); }
    catch { setHata('Veriler yüklenemedi.'); }
    setYukleniyor(false);
  }, []);

  useEffect(() => { veriYukle(); }, [veriYukle]);

  async function kaydet(form) {
    setKaydediliyor(true); setHata(null);
    try {
      if (form.misafirTipiId) await apiRequest('misafirtipleri', 'PUT', form);
      else await apiRequest('misafirtipleri', 'POST', form);
      await veriYukle(); setView('liste'); setSecili(null);
    } catch { setHata('Kayıt sırasında hata oluştu.'); }
    setKaydediliyor(false);
  }

  async function handleSil(id) {
    try { await apiRequest(`misafirtipleri/${id}`, 'DELETE'); setListe(p => p.filter(x => x.misafirTipiId !== id)); setSilOnay(null); }
    catch (e) { alert(e?.message || 'Hata oluştu.'); }
  }

  const filtrelenmis = liste
    .filter(x => x.ad?.toLocaleLowerCase('tr-TR').includes(arama.toLocaleLowerCase('tr-TR')))
    .sort((a, b) => {
      if (siralama === 'fiyat-asc') return a.gecelikFiyat - b.gecelikFiyat;
      if (siralama === 'fiyat-desc') return b.gecelikFiyat - a.gecelikFiyat;
      return a.ad.localeCompare(b.ad, 'tr-TR');
    });

  const ozelFiyatlilar = liste.filter(x => x.gecelikFiyat > 0);
  const ortFiyat = ozelFiyatlilar.length ? ozelFiyatlilar.reduce((s, x) => s + x.gecelikFiyat, 0) / ozelFiyatlilar.length : 0;
  const isOpen = view === 'ekle' || view === 'duzenle';

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="👥"
        iconColor="from-violet-500 to-purple-700"
        iconShadow="shadow-violet-200"
        title="Misafir Tipleri"
        subtitle="Misafir kategorileri ve türe özel fiyat yönetimi"
      >
        <button onClick={() => { setSecili(null); setView('ekle'); setHata(null); }}
          className="group flex-shrink-0 flex items-center justify-center gap-3 bg-gradient-to-r from-violet-600 to-purple-700 hover:from-violet-700 hover:to-purple-800 text-white px-10 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-violet-200 transition-[background-color,transform] duration-300 hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest relative overflow-hidden">
          <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
          <span className="relative text-xl transition-transform group-hover:rotate-90">＋</span>
          <span className="relative">YENİ MİSAFİR TİPİ EKLE</span>
        </button>
      </PageHeader>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: 'TOPLAM TİP', value: liste.length, icon: '👥', color: 'from-gray-700 to-gray-900 shadow-gray-200' },
          { label: 'ÖZEL FİYATLI', value: ozelFiyatlilar.length, icon: '💰', color: 'from-violet-500 to-violet-700 shadow-violet-100' },
          { label: 'VARSAYILAN', value: liste.filter(x => x.gecelikFiyat === 0).length, icon: '🔄', color: 'from-purple-500 to-purple-700 shadow-purple-100' },
          { label: 'ORT. ÖZEL FİYAT', value: `${ortFiyat.toFixed(0)} ₺`, icon: '📊', color: 'from-fuchsia-500 to-pink-700 shadow-pink-100' },
        ].map(k => (
          <div key={k.label} className={`relative overflow-hidden bg-gradient-to-br ${k.color} rounded-[2rem] p-6 text-white shadow-xl hover:shadow-2xl transition-[box-shadow,transform] duration-300 group`}>
            <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 pointer-events-none group-hover:scale-125 transition-transform duration-500">{k.icon}</div>
            <p className="text-[10px] font-black uppercase tracking-widest opacity-70 mb-1 leading-none">{k.label}</p>
            <p className="text-2xl font-black tracking-tight leading-none">{k.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm overflow-hidden min-h-[400px]">
        <div className="px-6 md:px-8 py-5 border-b border-gray-100 bg-gray-50/30 flex flex-col md:flex-row items-center gap-6">
          <div className="relative flex-1 w-full text-left">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-black">🔍</span>
            <input value={arama} onChange={e => setArama(e.target.value)} placeholder="Misafir tipi ara..."
              className="w-full pl-11 pr-4 py-3.5 text-sm border-2 border-gray-100 rounded-2xl focus:border-violet-400 focus:outline-none bg-white shadow-sm transition-all font-bold" />
          </div>
          <div className="flex items-center gap-4 w-full md:w-auto">
            <select value={siralama} onChange={e => setSiralama(e.target.value)}
              className="flex-1 md:flex-none text-[10px] font-black border-2 border-gray-100 rounded-2xl px-6 py-3.5 focus:outline-none focus:border-violet-400 bg-white shadow-sm uppercase tracking-widest h-[54px] appearance-none cursor-pointer pr-10 relative">
              <option value="ad">A-Z Sırala</option>
              <option value="fiyat-asc">Fiyat ↑</option>
              <option value="fiyat-desc">Fiyat ↓</option>
            </select>
            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-auto md:ml-0 whitespace-nowrap">TANIMLI: <b className="text-violet-600 text-xs">{liste.length}</b></p>
          </div>
        </div>

        {/* Mobile View */}
        <div className="md:hidden divide-y divide-gray-100 px-2 leading-none">
          {yukleniyor ? (
            <LoadingSpinner fullPage text="Veriler Çekiliyor..." />
          ) : filtrelenmis.length === 0 ? (
            <EmptyState icon="👥" text="Eşleşen tip bulunamadı" />
          ) : filtrelenmis.map(item => (
            <div key={item.misafirTipiId} className="p-6 flex flex-col gap-5 hover:bg-violet-50/20 transition-all rounded-[2rem] group">
              <div className="flex items-center gap-5 text-left leading-none">
                <div className="w-14 h-14 bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl flex-shrink-0 flex items-center justify-center font-black text-xl text-violet-600 shadow-xl border border-violet-100 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 transform-gpu leading-none">
                  {item.ad[0]}
                </div>
                <div className="min-w-0">
                  <p className="font-black text-gray-800 text-lg tracking-tight uppercase truncate leading-none mb-2">{item.ad}</p>
                  <p className={`text-[10px] font-black tracking-widest uppercase transition-colors duration-300 leading-none inline-block px-2.5 py-1 rounded-lg border ${item.gecelikFiyat > 0 ? 'bg-emerald-50 text-emerald-500 border-emerald-100' : 'bg-gray-50 text-gray-400 border-gray-100'}`}>
                    {item.gecelikFiyat > 0 ? `${item.gecelikFiyat.toFixed(2)} ₺ / GECE` : 'STANDART FİYAT'}
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                <EditButton size="lg" onClick={() => { setSecili(item); setView('duzenle'); setHata(null); }} />
                <DeleteButton size="lg" onClick={() => setSilOnay(item.misafirTipiId)} />
              </div>
            </div>
          ))}
        </div>

        {/* Desktop View */}
        <div className="hidden md:block overflow-x-auto leading-none">
          <DataTable
            anahtarAlan="misafirTipiId"
            satirlar={yukleniyor ? [] : filtrelenmis}
            bosIkon="👥"
            bosMetin={yukleniyor ? 'Veriler çekiliyor…' : 'Tanımlı misafir tipi bulunamadı'}
            kolonlar={[
              {
                anahtar: 'sira', baslik: '#', genislik: 'w-20',
                ciz: (item, i) => <span className="font-black text-gray-300 text-xs">{i + 1}</span>,
              },
              {
                anahtar: 'ad', baslik: 'Misafir Tipi',
                ciz: item => (
                  <div className="flex items-center gap-5 min-w-0">
                    <div className="w-12 h-12 bg-white rounded-2xl shadow-lg shadow-violet-50 border border-gray-100 flex-shrink-0 flex items-center justify-center text-xl font-black text-violet-600">
                      {item.ad[0]}
                    </div>
                    <span className="font-black text-gray-700 text-lg uppercase tracking-tight truncate">{item.ad}</span>
                  </div>
                ),
              },
              {
                anahtar: 'gecelikFiyat', baslik: 'Oda Başı / Gece', hizala: 'orta', genislik: 'w-56',
                ciz: item => (
                  <div className={'inline-flex items-center px-4 py-2.5 rounded-2xl border ' +
                    (item.gecelikFiyat > 0 ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-gray-50 text-gray-400 border-gray-200')}>
                    <span className="text-xs font-black uppercase tracking-[0.1em]">
                      {item.gecelikFiyat > 0 ? item.gecelikFiyat.toLocaleString('tr-TR') + ' ₺' : 'STANDART'}
                    </span>
                  </div>
                ),
              },
              {
                anahtar: 'kisiBazliFiyat', baslik: 'Kişi Başı / Gece', hizala: 'orta', genislik: 'w-56',
                ciz: item => (
                  <div className={'inline-flex items-center px-4 py-2.5 rounded-2xl border ' +
                    (item.kisiBazliFiyat > 0 ? 'bg-blue-50 text-blue-600 border-blue-100' : 'bg-gray-50 text-gray-400 border-gray-200')}>
                    <span className="text-xs font-black uppercase tracking-[0.1em]">
                      {item.kisiBazliFiyat > 0 ? item.kisiBazliFiyat.toLocaleString('tr-TR') + ' ₺' : 'TANIMLI DEĞİL'}
                    </span>
                  </div>
                ),
              },
              {
                anahtar: 'islem', baslik: 'İşlemler', hizala: 'sag',
                ciz: item => (
                  <ActionButtons
                    onEdit={() => { setSecili(item); setView('duzenle'); setHata(null); }}
                    onDelete={() => setSilOnay(item.misafirTipiId)} />
                ),
              },
            ]}
          />
        </div>
      </div>

      <UsageInfo
        color="violet"
        description="Misafir Tipleri modülü, VIP müşteriler, kurumsal firma personelleri veya kamu görevlileri gibi farklı kategorideki misafirler için özel fiyat politikaları belirlemenizi sağlar."
        scenarios={[
          { title: "Statü Bazlı Fiyatlandırma", content: "Örneğin; 'VIP' misafirler için oda fiyatına ek olarak her gece için sabit bir hizmet bedeli ekleyebilir veya kampanya dönemlerinde belirli tipler için indirimli sabit fiyatlar tanımlayabilirsiniz." },
          { title: "Kurumsal Anlaşmalar", content: "Kamu personeli veya anlaşmalı şirket çalışanları için ('SİVİL' vs 'KAMU'), rezarvasyonun ana oda fiyatı üzerinden ön tanımlı bir fiyatlandırma yapılmasını sağlar." },
          { title: "Rapor Hazırlama", content: "Otelde konaklayan misafirlerin demografik dağılımını (Örn: %30 VIP, %70 SİVİL) raporlayarak gelecekteki pazarlama stratejilerinizi belirleyebilirsiniz." }
        ]}
      />

      {isOpen && createPortal(
        <MisafirTipiForm
          kayit={secili}
          onKaydet={kaydet}
          onGeri={() => { setView('liste'); setSecili(null); setHata(null); }}
          kaydediliyor={kaydediliyor}
          hata={hata}
        />,
        document.body
      )}

      {silOnay && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center px-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm text-center border border-gray-100">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle leading-none">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight uppercase leading-none">Tipi Sil</h3>
            <p className="text-[11px] font-black text-gray-500 mt-5 mb-10 leading-relaxed uppercase tracking-tight text-center">
              <b className="text-gray-900 font-black uppercase">"{liste.find(x => x.misafirTipiId === silOnay)?.ad}"</b> misafir tipi kalıcı olarak silinecek. Emin misiniz?
            </p>
            <div className="flex gap-4">
              <button onClick={() => setSilOnay(null)} className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
              <button onClick={() => handleSil(silOnay)} className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-200 transition-all uppercase tracking-widest active:scale-95">EVET, SİL</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}